import React from 'react'
import PropTypes from 'prop-types'
import FinancialServices from '../FinancialServices'
import { fetchFinancialServices } from './financialServicesContainerActions'
import { serviceSelected } from '../searchCriteriaActions'
import { connect } from 'react-redux'
import Spinner from '../../../common/Spinners/Spinner'
import { bindActionCreators } from 'redux'

class FinancialServicesContainer extends React.Component {
  static propTypes = {
    financialServices: PropTypes.array.isRequired,
    serviceSelected: PropTypes.func.isRequired,
    fetchFinancialServices: PropTypes.func.isRequired,
    selectedServices: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    validation: PropTypes.object.isRequired,
    showValidationErrors: PropTypes.bool.isRequired
  }

  shouldComponentUpdate (nextProps) {
    let { financialServices, selectedServices, loading, validation, showValidationErrors } = this.props
    
    // Guard against undefined props
    if (!financialServices || !selectedServices || !nextProps.financialServices || !nextProps.selectedServices) {
      return true
    }
    
    var validationstateChanged = validation.help !== nextProps.validation.help ||
      validation.valid !== nextProps.validation.valid

    var shouldUpdate = loading !== nextProps.loading ||
      selectedServices.length !== nextProps.selectedServices.length ||
      financialServices.length !== nextProps.financialServices.length ||
      validationstateChanged || showValidationErrors !== nextProps.showValidationErrors

    return shouldUpdate
  }

  componentDidMount () {
    this.props.fetchFinancialServices()
  }

  render () {
    const { loading, financialServices, serviceSelected, selectedServices, validation } = this.props
    if (loading) {
      return <Spinner />
    }
    return <FinancialServices
      financialServices={financialServices}
      serviceSelected={serviceSelected}
      validation={validation}
      showValidationErrors={this.props.showValidationErrors}
      selectedServices={selectedServices} />
  }
}

const mapStateToProps = (state) => {
  return {
    financialServices: state.financialServicesContainer.financialServices,
    selectedServices: state.findAnIfa.searchCriteria.financialServices,
    loading: state.financialServicesContainer.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    serviceSelected: serviceSelected,
    fetchFinancialServices: fetchFinancialServices
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FinancialServicesContainer)
